import { Component } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';

// Catches render-time errors so one malformed state-replace from the leader
// (or any broken activity payload over WS) doesn't take down every phone in
// the room. Recovery is a manual reload — the WS reconnects with the same cid.
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    try { console.error('SDA render crash', error, info?.componentStack); } catch {}
  }
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{
        minHeight: '100vh', background: '#0a0a0a', color: '#fafafa',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 24, fontFamily: 'system-ui, sans-serif', textAlign: 'center',
      }}>
        <div style={{ maxWidth: 360 }}>
          <div style={{ fontSize: 56, marginBottom: 12 }}>⚠️</div>
          <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8, color: '#f5c518' }}>
            Kurzer Aussetzer
          </div>
          <div style={{ fontSize: 13, color: '#a1a1aa', marginBottom: 24, lineHeight: 1.5 }}>
            Die App hat einen Anzeige-Fehler gehabt. Tippe „Neu laden“ — danach geht's weiter, dein Name und Spielstand bleiben erhalten.
          </div>
          <button onClick={() => location.reload()}
            style={{
              background: '#f5c518', color: '#000', border: 'none',
              borderRadius: 12, padding: '14px 28px', fontSize: 15, fontWeight: 700,
              cursor: 'pointer',
            }}>
            Neu laden
          </button>
        </div>
      </div>
    );
  }
}

createRoot(document.getElementById('root')).render(
  <ErrorBoundary><App /></ErrorBoundary>
);
